import React, {Fragment, useContext, useState} from 'react';
import {
    Button, Snackbar,
} from '@material-ui/core';
import {Formik, Form} from 'formik';

import validationSchema from './FormModel/validationSchema';
import formModel from './FormModel/formModel';
import formInitialValues from './FormModel/formInitialValues';

import useStyles from './styles';
import axios from 'axios';

import car_white_icon from "../../../../../assets/images/white_car_icon.png";
import ConfirmarForm from "./Forms/ConfirmarForm";
import AuthContext from "../../../../../context/AuthContext";
import ConfirmacionSuccess from "./ConfirmacionSuccess";
import Alert from "@material-ui/lab/Alert";
import IndicatorsContext from "../../../../../context/AdviserContext/IndicatorsContext";

const steps = ['Confirmación'];
const {formId, formField} = formModel;

export default function CheckoutConfirmar(props) {
    const classes = useStyles();
    const {rowData} = props;
    const [activeStep, setActiveStep] = useState(0);
    const {authToken} = useContext(AuthContext)
    const {handleModified} = useContext(IndicatorsContext)
    const currentValidationSchema = validationSchema[activeStep];
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState(null);

    let filledFormInitialValues = {
        ...formInitialValues,
        ajusteAutomatico: rowData.AjusteAutomatico,
        cuotas: rowData.Cuotas,
        frecuenciaPago: rowData.FrecuenciaPago,
        tieneGnc: rowData.TieneGNC,
        afinidad: rowData.idAfinidad,
        idCotizacion: rowData.idCotizacion,
        descuentoCliente: rowData.DescuentoCliente,
        descuentoExtra: rowData.descuentoExtra ?? 0,
        vehiculo: {
            ...formInitialValues.vehiculo,
            marca: rowData.Marca,
            modelo: rowData.Modelo,
            anio: rowData.Anio,
            version: rowData.Version,
            valor: rowData.SumaAsegurada,
            detalle_marca: rowData.DetalleMarca,
            detalle_modelo: rowData.DetalleModelo,
            detalle_version: rowData.DetalleVersion,
            tieneGnc: rowData.TieneGNC,
            ceroKm: rowData.CeroKm.toString(),
            gnc: {
                ...formInitialValues.vehiculo.gnc,
                valorTotal: rowData.ValorGNC
            }
        }
    }

    if (rowData.Clientes !== null) {
        filledFormInitialValues = {
            ...filledFormInitialValues,
            clientes: [
                {
                    ...formInitialValues.clientes[0],
                    nombre: rowData.Clientes.Nombre,
                    apellido: rowData.Clientes.Apellido,
                    dni: rowData.Clientes.DNI.toString(),
                    codigoArea: rowData.Clientes.CodArea,
                    telefono: rowData.Clientes.Telefono,
                    email: rowData.Clientes.Email,
                    cuit: ''
                }
            ],
        }
        if (rowData.Clientes.Patente !== "") {
            filledFormInitialValues = {
                ...filledFormInitialValues,
                vehiculo: {
                    ...filledFormInitialValues.vehiculo,
                    patente: rowData.Clientes.Patente,
                }
            }
        }
    }

    const handleOpenAlert = (message) => {
        setOpenAlert(true);
        setAlertMessage(message);
    };

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenAlert(false);
        setAlertMessage(null);
    };

    async function _submitForm(values, actions) {
        let url = process.env.REACT_APP_BACK_SERVER + '/guardarEmision';

        values.origen = "affinity"
        values.emailDespachoElectronico = values.clientes[0].email
        values.despachoElectronico = 'true'
        values.vehiculo.equipoDeRastreo = 'false'
        values.vehiculo.gnc.valorTotal = values.vehiculo.gnc.valorTotal === '0.0' ? '0' : values.vehiculo.gnc.valorTotal
        values.descuentoEspecial = 0;
        setLoading(true)

        axios.post(url, values, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${authToken}`,
            }
        }).then(res => {
            setResponse(res.status);
            actions.setSubmitting(false);
            setLoading(false)
            setActiveStep(activeStep + 1);
            handleModified()
        }).catch(err => {
            handleOpenAlert("Ha ocurrido un error al intentar guardar: " + err)
            actions.setSubmitting(false);
            setLoading(false)
        });
    }

    function _handleSubmit(values, actions) {
        _submitForm(values, actions);
        actions.setTouched({});
        actions.setSubmitting(true);
    }

    return (
        <React.Fragment>
            <div className={classes.formBox}>
                <div className={classes.iconCircle}>
                    <img src={car_white_icon} alt="white_car_icon" style={{width: "32px", height: "auto"}}/>
                </div>
                <Fragment>
                    {activeStep === steps.length ? (
                        <ConfirmacionSuccess loading={loading} response={response}/>
                    ) : (
                        <Formik
                            initialValues={filledFormInitialValues}
                            validationSchema={currentValidationSchema}
                            validateOnBlur={false}
                            onSubmit={_handleSubmit}
                        >
                            {({isSubmitting}) => (
                                <Form id={formId}>
                                    <ConfirmarForm formField={formField}/>
                                    <div className={classes.buttons}>
                                        <div className={classes.buttons}>
                                            <Button
                                                disabled={isSubmitting}
                                                type="submit"
                                                variant="contained"
                                                color="primary"
                                                className={classes.buttonContained}
                                            >
                                                Confirmar Emisión
                                            </Button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    )}
                </Fragment>
            </div>
            <Snackbar open={openAlert && alertMessage} autoHideDuration={5000} onClose={handleCloseAlert}>
                <Alert onClose={handleCloseAlert} severity="warning" elevation={6} variant="filled"
                       classes={{filledWarning: classes.alert}}
                >
                    {alertMessage}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}
